<!-- **** --------------------------------------------------------------------------
	SHARED SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts">
    import vm from '@journeys/Journeys.viewmodel';
    import ScrollableContainer from '@shared/components/ScrollableContainer.vue';
</script>

<!-- **** --------------------------------------------------------------------------
	SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts" setup>
    // components
    import FluidButton from '@cwd/shared/components/FluidButton.vue';
    import FluidSelect from '@cwd/shared/components/FluidSelect.vue';
    import FluidInput from '@cwd/shared/components/FluidInput.vue';

    import { bitshift } from '@shared/utils';

    const { canvas, editor, nav, settings } = vm;

    const props = defineProps<{}>();

    let selectInputTest: any = {
        '1': {
            id: '1',
            hex: '#CCFF00',
            rgb: 'rgb(204,255,0)',
            hsl: 'hsl(72,100%,50%)',
        },
        '2': {
            id: '2',
            hex: '#CCCC00',
            rgb: 'rgb(204,204,0)',
            hsl: 'hsl(60,100%,40%)',
        },
        '3': {
            id: '3',
            hex: '#CC9900',
            rgb: 'rgb(204,153,0)',
            hsl: 'hsl(45,100%,40%)',
        },
        '4': {
            id: '4',
            hex: '#CC6600',
            rgb: 'rgb(204,102,0)',
            hsl: 'hsl(30,100%,40%)',
        },
        '5': {
            id: '5',
            hex: '#CC3300',
            rgb: 'rgb(204,51,0)',
            hsl: 'hsl(15,100%,40%)',
        },
        '6': {
            id: '6',
            hex: '#CC0000',
            rgb: 'rgb(204,0,0)',
            hsl: 'hsl(0,100%,40%)',
        },
        '7': {
            id: '7',
            hex: '#660000',
            rgb: 'rgb(102,0,0)',
            hsl: 'hsl(0,100%,20%)',
        },
        '8': {
            id: '8',
            hex: '#663300',
            rgb: 'rgb(102,51,0)',
            hsl: 'hsl(30,100%,20%)',
        },
        '9': {
            id: '9',
            hex: '#666600',
            rgb: 'rgb(102,102,0)',
            hsl: 'hsl(60,100%,20%)',
        },
        '10': {
            id: '10',
            hex: '#669900',
            rgb: 'rgb(102,153,0)',
            hsl: 'hsl(80,100%,30%)',
        },
        '11': {
            id: '11',
            hex: '#66CC00',
            rgb: 'rgb(102,204,0)',
            hsl: 'hsl(90,100%,40%)',
        },
        '12': {
            id: '12',
            hex: '#66FF00',
            rgb: 'rgb(102,255,0)',
            hsl: 'hsl(96,100%,50%)',
        },
        '13': {
            id: '13',
            hex: '#00FF00',
            rgb: 'rgb(0,255,0)',
            hsl: 'hsl(120,100%,50%)',
        },
        '14': {
            id: '14',
            hex: '#00CC00',
            rgb: 'rgb(0,204,0)',
            hsl: 'hsl(120,100%,40%)',
        },
        '15': {
            id: '15',
            hex: '#009900',
            rgb: 'rgb(0,153,0)',
            hsl: 'hsl(120,100%,30%)',
        },
        '16': {
            id: '16',
            hex: '#006600',
            rgb: 'rgb(0,102,0)',
            hsl: 'hsl(120,100%,20%)',
        },
        '17': {
            id: '17',
            hex: '#003300',
            rgb: 'rgb(0,51,0)',
            hsl: 'hsl(120,100%,10%)',
        },
        '18': {
            id: '18',
            hex: '#000000',
            rgb: 'rgb(0,0,0)',
            hsl: 'hsl(0,0%,0%)',
        },
        '19': {
            id: '19',
            hex: '#CCFF33',
            rgb: 'rgb(204,255,51)',
            hsl: 'hsl(75,100%,60%)',
        },
        '20': {
            id: '20',
            hex: '#CCCC33',
            rgb: 'rgb(204,204,51)',
            hsl: 'hsl(60,60%,50%)',
        },
        '21': {
            id: '21',
            hex: '#CC9933',
            rgb: 'rgb(204,153,51)',
            hsl: 'hsl(40,60%,50%)',
        },
        '22': {
            id: '22',
            hex: '#CC6633',
            rgb: 'rgb(204,102,51)',
            hsl: 'hsl(20,60%,50%)',
        },
        '23': {
            id: '23',
            hex: '#CC3333',
            rgb: 'rgb(204,51,51)',
            hsl: 'hsl(0,60%,50%)',
        },
        '24': {
            id: '24',
            hex: '#CC0033',
            rgb: 'rgb(204,0,51)',
            hsl: 'hsl(345,100%,40%)',
        },
        '25': {
            id: '25',
            hex: '#660033',
            rgb: 'rgb(102,0,51)',
            hsl: 'hsl(330,100%,20%)',
        },
        '26': {
            id: '26',
            hex: '#663333',
            rgb: 'rgb(102,51,51)',
            hsl: 'hsl(0,33%,30%)',
        },
        '27': {
            id: '27',
            hex: '#666633',
            rgb: 'rgb(102,102,51)',
            hsl: 'hsl(60,33%,30%)',
        },
        '28': {
            id: '28',
            hex: '#669933',
            rgb: 'rgb(102,153,51)',
            hsl: 'hsl(90,50%,40%)',
        },
        '29': {
            id: '29',
            hex: '#66CC33',
            rgb: 'rgb(102,204,51)',
            hsl: 'hsl(100,60%,50%)',
        },
        '30': {
            id: '30',
            hex: '#66FF33',
            rgb: 'rgb(102,255,51)',
            hsl: 'hsl(105,100%,60%)',
        },
        '31': {
            id: '31',
            hex: '#00FF33',
            rgb: 'rgb(0,255,51)',
            hsl: 'hsl(132,100%,50%)',
        },
        '32': {
            id: '32',
            hex: '#00CC33',
            rgb: 'rgb(0,204,51)',
            hsl: 'hsl(135,100%,40%)',
        },
        '33': {
            id: '33',
            hex: '#009933',
            rgb: 'rgb(0,153,51)',
            hsl: 'hsl(140,100%,30%)',
        },
        '34': {
            id: '34',
            hex: '#006633',
            rgb: 'rgb(0,102,51)',
            hsl: 'hsl(150,100%,20%)',
        },
        '35': {
            id: '35',
            hex: '#003333',
            rgb: 'rgb(0,51,51)',
            hsl: 'hsl(180,100%,10%)',
        },
        '36': {
            id: '36',
            hex: '#000033',
            rgb: 'rgb(0,0,51)',
            hsl: 'hsl(240,100%,10%)',
        },
    };

    let dummy = { v: '' };
</script>

<!-- **** --------------------------------------------------------------------------
	TEMPLATE
-------------------------------------------------------------------------- **** -->
<template>
    <ScrollableContainer>
        <div class="section-group">
            <div class="button-container">
                <FluidButton text="Apply" @click="() => {}" class="large-button mandy" />
                <FluidButton text="Cancel" @click="() => {}" class="text-button" />
            </div>
        </div>

        <div class="section-group">
            <div class="input-wrapper fl-d-col align-fl-items-s">
                <h4>Frame</h4>
                <div class="swatch-wrapper fl">
                    <div
                        class="color-swatch"
                        :style="{
                            backgroundColor: 'red',
                        }"
                        @click.left="() => {}"></div>
                    <h4>color</h4>
                </div>
            </div>
            <div class="input-wrapper fl-d-col align-fl-items-s mt-xs">
                <h4>Icon</h4>
                <div class="swatch-wrapper fl">
                    <div
                        class="color-swatch"
                        :style="{
                            backgroundColor: 'blue',
                        }"
                        @click.left="() => {}"></div>
                    <h4>color</h4>
                </div>
            </div>
        </div>

        <FluidSelect v-model:value="dummy.v" :items="selectInputTest" selectionProp="id" displayProp="hsl" />

        <div class="section-group mt-sm">
            <FluidInput v-model:value="dummy.v" />
        </div>

        <div class="section-group mt-sm">
            <FluidInput class="minimal" v-model:value="dummy.v" />
        </div>
    </ScrollableContainer>
</template>

<!-- **** --------------------------------------------------------------------------
	STYLES
-------------------------------------------------------------------------- **** -->
<style></style>
